import { nanoid } from "nanoid";
import bus from "@/utils/bus";
import { AuthBackend, CentralBackend } from "@/utils/authBackend";
import AuthBackendV2 from "@/utils/authBackendV2";
import axios from "axios";
// import store from '../store'

const isLocal = window.location.host === "localhost:8080";

// const API = axios.create({
//   // withCredentials: true,
//   baseURL: `https://adctv-backend.herokuapp.com/v1/`,
//   //baseURL: `http://localhost:9999/v1/`,
//   // baseURL: `https://staging.adctv.com/v1/`
// });

/**
 * Idempotent request interceptor
 */

const idempotentInterceptor = (config) => {
  if (!config.headers) {
    config.headers = {};
  }

  //reuse existing idempotent key if request is a retry
  if (config.headers["Idempotency-Key"]) {
    return config;
  }
  const id = nanoid();
  config.headers["Idempotency-Key"] = id;
  return config;
};

AuthBackend.interceptors.request.use(idempotentInterceptor);

AuthBackend.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      // Prevent multiple triggers
      if (!window.__logoutTriggered) {
        window.__logoutTriggered = true;

        bus.emit("user:logout");
      }
    }
    return Promise.reject(error);
  }
);

// add idempotent interceptor to v2 backend
AuthBackendV2.interceptors.request.use(idempotentInterceptor);

AuthBackendV2.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      // Prevent multiple triggers
      if (!window.__logoutTriggered) {
        window.__logoutTriggered = true;

        bus.emit("user:logout");
      }
    }
    return Promise.reject(error);
  }
);

const handleError = (error) => {
  const errorMsg = {
    message: "Something went wrong, please try again later",
    details: [],
  };
  //handle axios error
  if (error.response) {
    const { data } = error.response;

    errorMsg.message = data.message;

    if (data.data) {
      for (let errorKey in data.data) {
        errorMsg.details = errorMsg.details.concat(data.data[errorKey]);
      }
    }
  }
  return errorMsg;
};

/**
 * Fetch Component from server
 * @async
 * @function fetchComponents
 * @return {Promise<array>}
 */
export const fetchComponents = async () => {
  const { data } = await AuthBackend.get("component");
  return data.data;
};



/**
 * Fetch Templates from server
 * @async
 * @function fetchTemplates
 * @return {Promise<array>}
 */
export const fetchTemplates = async () => {
  const { data } = await AuthBackend.get("template-category");
  return data.data;
};

/**
 * Upload Files
 * @async
 * @function uploadFiles
 * @return {Promise<array>}
 */
export const uploadFiles = async (creativeId, userId, fileType, name, mimetype, assetId, assetFolderId = null, accessId, groupId, brandKitId) => {
  const { data } = await AuthBackend.post("asset-upload-request-signed-url", {
    creativeId, userId, fileType, name, mimetype, assetId, assetFolderId, accessId, groupId,  brandKitId
  });
  return data.data;
}

/**
 * Upload Font
 * @async
 * @function uploadFont
 * @return {Promise<array>}
 */
export const uploadFont = async (file) => {
  const { data } = await AuthBackend.post("save-font-file", file);
  return data.data;
}

export const uploadFontFile = async (creativeId, userId, fileType, name, mimetype, assetId) => {

  const fontData = await uploadFiles(creativeId, userId, fileType, name, mimetype, assetId);
  // const { data } = await AuthBackend.post("upload-font",file);
  // return data.data;
}


/**
 * Get Font Name
 * @async
 * @function getFontName
 * @return {Promise<array>}
 */
export const getFontName = async (src) => {
  // let data = JSON.stringify({
  //   src
  // })
  const {data} = await AuthBackend.get(`get-font-name?url=${src}`);
  return data;
};

/**
 * Upload Files Meta Data
 * @async
 * @function uploadFilesMetaData
 * @return {Promise<array>}
 */
export const uploadFilesMetaData = async (assetId, width, height, size, name, duration, accessId = null, assetFolderId, brandKitId) => {

  await AuthBackend.put(`set-asset-metadata`,  {
    assetId,
    assetData: {
      'assetId': assetId,
      'width': width,
      'height': height,
      'size': size,
      'duration': duration
    },
    accessId,
    assetFolderId,
    brandKitId,
    name
  });
};

/**
 * Fetch template definitions from server
 * @async
 * @function fetchTemplateDefinition
 * @param {string} templateURI - URI to the template.json
 * @return {Promise<object>}
 **/

export const fetchTemplateDefinition = async (templateURI) => {
  const { data } = await AuthBackend.get(templateURI);
  return data;
};
//TODO: remove this if everything is working
// export const publishCreative = async ({ video, html }) => {
//   try {
//     const { data } = await API.post("/publish-creative", { video, html });

//     if (data.error) {
//       throw new Error(data.response);
//     }

//     return data.url;
//   } catch (err) {
//     console.log(err);
//     throw err;
//   }
// };

export const openCreative = async (
  adType,
  name,
  campaignId,
  advertiserName,
  publisherName,
  creativeName,
  templateId,
  height,
  width,
  isResponsive,
  expansionMode,
  insertionMode,
  expCanvasHeight,
  expCanvasWidth
) => {
  try {
    const { data } = await AuthBackend.post("/campaign", {
      adType,
      name,
      campaignId,
      advertiserName,
      publisherName,
      width,
      height,
      creativeName,
      templateId,
      isResponsive,
      
      expansionMode,
      insertionMode,
      expCanvasHeight,
      expCanvasWidth
    });

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * Get creatives/ad-types
* @async getCreativeAdTypes
 * @returns {Promise<object>}
 */

export const getCreativeAdTypes = async (withAll = false) => {
  try {
    const { data } = await AuthBackend.get(`creatives/ad-types?withAll=${withAll}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get insertion-types
* @async getInsertionTypes
 * @returns {Promise<object>}
 */

export const getInsertionTypes = async () => {
  try {
    const { data } = await AuthBackend.get(`placement-insertion-types`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Fetch XSRF-TOKEN from server
 * @async
 * @function getXSRF
 * @return {Promise<string>}
 **/
export const getXSRF = async () => {
  const URL = isLocal
    ? `${process.env.VITE_APP_BACKEND_DEV}/sanctum/csrf-cookie`
    : `${window.location.origin}/sanctum/csrf-cookie`;
  try {
    await AuthBackend.get(URL);
  } catch (err) {
    console.log(err);
  }
};

/**
 * Login as user
 * @async login
 * @param {string} email - Email of user
 * @param {string} password - Password of user
 * @return {Promise<object>}
 **/
export const login = async (email, password) => {
  try {
    const { data } = await AuthBackend.post("auth/login", { email, password });
    // if isLocal, set the token in local storage
    if (isLocal) {
      localStorage.setItem("token", data.data.token);
      AuthBackend.defaults.headers['Authorization'] = `Bearer ${data.data.token}`
      AuthBackend.defaults.headers.common['Authorization'] = `Bearer ${data.data.token}`
      console.log(AuthBackend.defaults.headers);
    }
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get current user
 * @async getCurrentUser
 * @returns {Promise<object>}
 */

export const getCurrentUser = async () => {
  try {
    const { data } = await AuthBackend.get("/me");
    // store tenancy id in local storage for future
    if (data.data.user.tenantId) {
      localStorage.setItem("tenantId", data.data.user.tenantId);
      localStorage.setItem("logo", data.data.user.logo);
      let broadcastchannelName = 'public:user-' + data.data.user.tenantId + '-' + data.data.user.id;
      localStorage.setItem("broadcastchannelName", broadcastchannelName);
      
      let domain = data.data.user.domain;
      localStorage.setItem("domain", domain);
    }
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

// Create Password for users

export const createPasswordForUsers = async (userId, password, password_confirmation) => {
  try {
    const { data } = await AuthBackend.post("change-password", {
      userId, password, password_confirmation
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**
 * Get current user
 * @async getAdvertiserList
 * @returns {Promise<object>}
 */

export const getAdvertiserList = async (search) => {
  try {
    const { data } = await AuthBackend.get(`advertiser?advertiser=${search}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get current user
 * @async getCampaignList
 * @returns {Promise<object>}
 */

export const getCampaignList = async (search = '') => {
  try {
    const { data } = await AuthBackend.get(`campaign-search?q=${search}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get current user
 * @async getPublisherList
 * @returns {Promise<object>}
 */

export const getPublisherList = async (search = '') => {
  try {
    const { data } = await AuthBackend.get(`publisher?publisher=${search}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * get user info
 * @async getUserInfo
 * @return {Promise<object>}
 * */

export const getUserInfo = async () => {
  try {
    const { data } = await AuthBackend.get("user");
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * create user
 * @async createUser
 * @param {Object} user - user object
 * @return {Promise<object>}
 **/
export const createUser = async (user) => {
  try {
    const { data } = await AuthBackend.post("user", user);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get All Users
 * @async getUsers
 * @param {number} page - page number | defaults to 1
 * @param {string} search - search value | defaults to empty string
 * @return {Promise<object>}
 */

export const getUsers = async (page = 1, search = "", sort, order) => {
  try {
    const { data } = await AuthBackend.get(
      `user?sort=${sort}&order=${order}&page=${page}&q=${search}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Delete User by id
 * @async deleteUser
 * @param {number} id - user id
 * @return {Promise<object>}
 */

export const deleteUser = async (id) => {
  try {
    const { data } = await AuthBackend.delete(`user/${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get User by id
 * @async getUser
 * @param {number} id - user id
 * @return {Promise<object>}
 */

export const getUser = async (id) => {
  try {
    const { data } = await AuthBackend.get(`user/${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Update User by id
 * @async updateUser
 * @param {number} id - user id
 * @param {Object} user - user object
 * @return {Promise<object>}
 */

export const updateUser = async (id, user) => {
  try {
    const { data } = await AuthBackend.put(`user/${id}`, user);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get user roles
 * @async getUserRoles
 * @param {number} page - page number | defaults to 1
 * @return {Promise<object>}
 */

export const getUserRoles = async (page = 1) => {
  try {
    const { data } = await AuthBackend.get(`role?page=${page}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const generatePassword = async () => {
  try {
    const { data } = await AuthBackend.get(`generate-password`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get dashboard creatives with thumbnails
 * @async getCreativesList
 * @returns {Promise<object>}
 */

export const getCreativesList = async (page = 1, campaignId, search) => {
  try {
    const { data } = await AuthBackend.get(
      `/creative?campaignId=${campaignId}&page=${page}&q=${search}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get placement list
 * @async getPlacementsList
 * @returns {Promise<object>}
 */

export const getPlacementsList = async (creativeid) => {
  try {
    const { data } = await AuthBackend.get(
      `/placement?creativeId=${creativeid}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Add new placement
 * @async createPlacement
 * @param {string} name - placement name
 * @param {number} creativeId - creative id
 * @returns {Promise<object>}
 */
export const createPlacement = async (name, creativeId, adType, trackers ) => {
  try {
    const { data } = await AuthBackend.post("/placement", {
      name,
      creative_id: creativeId,
      ad_type: adType,
      trackers
    });

    if (data.error) {
      throw new Error(data.response);
    }

    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
/**
 * Delete placement by id
 * @async deletePlacement
 * @param {number} id - placement id
 * @return {Promise<object>}
 */

export const deletePlacement = async (id) => {
  try {
    const { data } = await AuthBackend.delete(`placement/${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get placement details by id
 * @async getPlacementDetails
 * @param {number|string} id - placement id
 * @return {Promise<object>}
 */
export const getPlacementDetails = async (id) => {
  try {
    const { data } = await AuthBackend.get(`placement/${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get placement tags by id
 * @async getPlacementTag
 * @param {number} id - placement id
 * @return {Promise<object>}
 */

export const getPlacementTag = async (id) => {
  try {
    const { data } = await AuthBackend.get(`get-placement-tags/${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * User profile details
 * @async updateUserProfile
 * @param {string} firstName -user first name
 * @param {string} lastName - user last name
 * @param {string} designation - user designation
 * @param {string} phone - user phone
 * @param {string} email -  user email
 * @param {string} timezone -  user timezone
 * @param {file} profileImage -  user profile image
 *
 * @returns {Promise<object>}
 */
export const updateUserProfile = async (
  firstName,
  lastName,
  designation,
  phone,
  email,
  timezone,
  profileImage
) => {
  try {
    const header = {};
    let postData;
    if (profileImage) {
      postData = new FormData();
      postData.append("firstName", firstName);
      postData.append("lastName", lastName);
      postData.append("designation", designation);
      postData.append("phone", phone);
      postData.append("email", email);
      postData.append("timezone", timezone);
      postData.append("profileImage", profileImage);
      header["Content-Type"] = "multipart/form-data";
    } else {
      postData = {
        firstName,
        lastName,
        designation,
        phone,
        email,
        timezone,
        profileImage,
      };
    }
    const { data } = await AuthBackend.post("/user-profile", postData);

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
/**
 * Get all campaigns
 * @async getCampaigns
 * @returns {Promise<object>}
 */

// export const getCampaigns = async (sort, order, page = 1, search) => {
//   try {
//     const { data } = await AuthBackend.get(
//       `/campaign?sort=${sort}&order=${order}&page=${page}&q=${search}`
//     );
//     return data;
//   } catch (err) {
//     throw handleError(err);
//   }
// };



//   Get all campaign's
export const getCampaigns = async (limit = 6, page = 1, search = '', sortBy, sortOrder)  => {
  try {
    const {data} = await AuthBackend.get('campaign', {
      params: {
        limit,
        page,
        q: search,
        sortBy,
        sortOrder,
      },
    });
    return data
  } catch (error) {
    throw handleError(error)
  }
}

/**
 * Get single campaign by id
 * @async getCampaignById
 * @param {number} id - campaign id
 * @returns {Promise<object>}
 */

export const getCampaignById = async (id) => {
  try {
    const { data } = await AuthBackend.get(
      `/campaign/${id}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Create new campaign
 * @async createCampaign
 * @param {string} name - campaign name
 * @param {string} advertiserName - advertiser name
 * @param {string} publisherName - publisher name
 * @returns {Promise<object>}
 */
export const createCampaign = async (campaignName, advertiserName, publisherName) => {
  try {
    const { data } = await AuthBackend.post("/campaign", {
      campaign_name: campaignName,
      advertiser_name: advertiserName,
      publisher_name: publisherName,
    });

    if (data.error) {
      throw new Error(data.response);
    }

    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
/**
 * Update existing campaign
 * @async updateCampaign
 * @param {number} id - campaign id
 * @param {string} name - campaign name
 * @param {string} advertiserName - advertiser name
 * @param {string} publisherName - publisher name
 * @returns {Promise<object>}
 */
export const updateCampaign = async (id, campaignName, advertiserName, publisherName) => {
  try {
    const { data } = await AuthBackend.put(`/campaign/${id}`, {
      campaign_name: campaignName,
      advertiser_name: advertiserName,
      publisher_name: publisherName,
    });

    if (data.error) {
      throw new Error(data.response);
    }

    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
/**
 * Delete campaign by id
 * @async deleteCampaign
 * @param {number} id - campaign id
 * @return {Promise<object>}
 */

export const deleteCampaign = async (id) => {
  try {
    const { data } = await AuthBackend.delete(`campaign/${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Logout user
 * @async logout
 * @returns {Promise<object>}
 */

export const logout = async () => {
  try {
    const { data } = await AuthBackend.post("auth/logout");
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateCreative = async ({
  creativeId,
  creativeVersion,
  content,
  html,
  thumbnail,
  duration,
  height,
  width,
  exitUrls,
  isResponsive
}) => {
  try {
    console.log("inside index",creativeId,
      creativeVersion,
      content,
      html,
      thumbnail,
      duration,
      height,
      width,
      exitUrls);
      /creative/id
    const { data } = await AuthBackend.post("/creative", {
      creativeId,
      creativeVersion,
      content,
      html,
      thumbnail,
      duration,
      height,
      width,
      exitUrls,
      isResponsive
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const uploadPreview = async (file) => {
  try {
    const { data } = await AuthBackend.post("/asset", file);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getCdnUrl = async (assetId) => {
  try {
    const { data } = await AuthBackend.get(`asset-cdn-url/${assetId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const loadCreative = async (creativeId) => {
  try {
    const { data } = await AuthBackend.get(`creative/${creativeId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


export const getCreativeContent = async (creativeId) => {
  try {
    const { data } = await AuthBackend.get(`get-creative-content/${creativeId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


export const updateCreativeNameAPI = async  (name, uniqueId, version, creativeId, isResponsive,content) => {
  try {
    const data = await AuthBackend.put(`/creative/${uniqueId}`, { name, creativeVersion: version, creativeId, isResponsive, content });
    return data
  } catch (error) {
    throw handleError(error);
  }
}

/**
 * Get comments by creative id
 * @async getComments
 * @param {number} id - creative id
 * @return {Promise<object>}
 */

export const getComments = async (id) => {
  try {
    const { data } = await AuthBackend.get(
      `comments?creativeId=${id.creativeId}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Add new placement
 * @async addComment
 * @param {number} creativeId - creative id
 * @param {string} message - comment
 * @returns {Promise<object>}
 */
export const addComment = async (creativeId, message) => {
  try {
    const { data } = await AuthBackend.put("/comments", {
      creativeId,
      message,
    });

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * Add new placement
 * @async addComment
 * @param {number} creativeId - creative id
 * @param {string} parentId - comment id of parent
 * @param {string} message - comment
 * @returns {Promise<object>}
 */
export const addSubComment = async (creativeId, parentId, message) => {
  try {
    const { data } = await AuthBackend.put("/comments", {
      creativeId,
      parentId,
      message,
    });
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * toggle resolve comments
 * @async resolveComment
 * @param {number} creativeId - creative id
 * @param {string} parentId - comment id of parent
 * @param {string} message - comment
 * @param {boolean} isResolved - true if resolved
 * @returns {Promise<object>}
 */
export const resolveComment = async (
  creativeId,
  parentId,
  message,
  isResolved
) => {
  try {
    const { data } = await AuthBackend.put("/comments", {
      creativeId,
      parentId,
      message,
      isResolved,
    });
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * Delete Comment by id
 * @async deleteComment
 * @param {number} creativeId - creative id
 * @param {number} parentId - parent id
 * @return {Promise<object>}
 */

export const deleteComment = async (creativeId, parentId, replyId) => {
  try {
    const { data } = await AuthBackend.put(`destroy-comments`, {
      creativeId,
      parentId,
      replyId
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get dashboard templates
 * @async getTemplates
 * @returns {Promise<object>}
 */

export const getTemplates = async (limit, page = 1, search) => {
  try {
    const { data } = await AuthBackend.get('template', {
      params: {
        limit,
        page,
        q: search,
      },
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get creatives list based on seleccted campaign
 * @async listCampaignCreatives
 * @returns {Promise<object>}
 */

export const listCampaignCreatives = async (campaignId, filter) => {
  try {
    const { data } = await AuthBackend.get(
      `campaign/creatives/${campaignId}?filter=${filter}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Update creative of a placement
 * @async updateCreativePlacement
 * @param {array} details - creative id,placement id
 * @return {Promise<object>}
 */

export const updateCreativePlacement = async (details) => {
  try {
    const { placementId } = details;
    const payload = {
      ...details,
      creative_id: details.creative_id ?? details.creativeId,
      ad_type: details.ad_type ?? details.adType,
    };
    delete payload.placementId;
    delete payload.creativeId;
    delete payload.adType;

    const { data } = await AuthBackend.put(`placement/${placementId}`, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get download tags list
 * @async getDownloadTags
 * @returns {Promise<object>}
 */



/**
 *   Download tag sorted by creatiev name
 * @returns 
 *
 */

export const exportPlacementTags = async (macros, placementIds) => {
  try {
    const { data } = await AuthBackend.post(`placements/export`, 
      {
        macros,
        placementIds
      },
      {
        responseType: "blob"
      }
    );
    console.log(data);
    return {
      data: URL.createObjectURL(data),
      error: 0,
    };
  } catch (err) {
    throw handleError(err);
  }
};




export const getDownloadTags = async () => {
  try {
    const { data } = await AuthBackend.get(`/macros`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Queue campaign tags export (async). Returns export_token for status polling.
 * @async downloadTag
 * @returns {Promise<object>}
 */
export const downloadTag = async (details) => {
  try {
    const { data } = await AuthBackend.post(`/campaign/export`, {
      campaignId: details.campaignId,
      macros: details.macros,
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getCampaignTagsExportStatus = async (token) => {
  try {
    const { data } = await AuthBackend.get(`campaign/export/status/${token}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**
 * PlACEMENT UPLOAD
 * POST
 */

export const placementUpload = async (formData) => {
  try {
    const { data } = await AuthBackend.post(`/placement-import`,
     formData
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Create copy of creative
 * @async copyCreative
 * @param {array} details - creative id,campaign id,new creative name
 * @return {Promise<object>}
 */
export const copyCreative = async (details) => {
  try {
    const creativeId = details.creative_id || details.creativeId;
    const endpoint = creativeId
      ? `/creatives/${encodeURIComponent(creativeId)}/copy`
      : "/copy-creative";
    const { data } = await AuthBackend.post(endpoint, details);

    if (data.error) {
      throw new Error(data.response);
    }

    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
/**
 * Get the html of a saved or drafted creative
 * @async getPreviewContent
 * @param {array} details - creative id,status- draft / published
 * @return {Promise<object>}
 */
export const getPreviewContent = async (creative) => {
  try {
    const { data } = await AuthBackend.get(
      `/preview/${creative.creativeId}/${creative.status}`
    );

    if (data.error) {
      throw new Error(data.response);
    }

    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
/**
 * Move creative to live (publish)
 * @async publishCreative
 * @param {string} creativeId - creative Id
 * @return {Promise<object>}
 **/
export const publishCreative = async (creativeId, html, duration, content, timedEvents, isResponsive) => {
  try {
    const { data } = await AuthBackend.post("publish-creative", {
      creativeId,
      html,
      duration,
      content,
      timedEvents,
      isResponsive
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Discard the draft creative changes
 * @async discardDraftChanges
 * @param {string} creativeId - creative Id
 * @return {Promise<object>}
 **/
export const discardDraftChanges = async (creativeId) => {
  try {
    const { data } = await AuthBackend.post(
      `discard-draft-changes`,
      creativeId
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const uploadThumbnail = async (file) => {
  try {
    const { data } = await AuthBackend.post("/thumbnail", file);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Download placement
 * @async downloadPlacement
 * @param {number} placementId - placement id
 * @return {Promise<object>}
 */

export const exportSinglePlacementTag = async (placementId, macros) => {
  try {
    const { data } = await AuthBackend.post(`/placement/${placementId}/export`,
      {
        macros: JSON.stringify(macros),
      },
      {
        responseType: "blob"
      }
    );
    return {
      data: URL.createObjectURL(data),
      error: 0,
    };
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get list of users creative is shared with
 * @async listCreativeSharedUsers
 * @param {string} creativeId - creative Id
 * @returns {Promise<object>}
 */

export const listCreativeSharedUsers = async (creativeId) => {
  try {
    const { data } = await AuthBackend.get(`creative/${creativeId}/share`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Forgot password request
 * @async forgotPassword
 * @param {string} email - email
 * @return {Promise<object>}
 */
export const forgotPassword = async (email) => {
  try {
    const { data } = await AuthBackend.post(`/auth/forgot-password`, email);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Share creative with users
 * @async setSharedUsers
 * @param {string} userIds - list of users id to share with
 * @param {number} creativeId - creative id
 * @returns {Promise<object>}
 */
export const setSharedUsers = async (creativeId, userIds) => {
  try {
    const { data } = await AuthBackend.post(`creative/${creativeId}/share`, {
      userIds,
    });

    if (data.error) {
      throw new Error(data.response);
    }

    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * Password reset
 * @async passwordReset
 * @param {array} details - token, new password, confirm password
 * @return {Promise<object>}
 */
export const passwordReset = async (token, password, password_confirmation) => {
  try {
    let resetData = {
      token: token,
      password: password,
      password_confirmation: password_confirmation,
    };
    const { data } = await AuthBackend.post(`/auth/reset-password`, resetData);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Change Password
 * @async changePassword
 * @param {array} details - old password, new password, confirm password
 * @return {Promise<object>}
 */
export const changePassword = async (old_password, password, password_confirmation) => {
  try {
    let changePasswordData = {
      old_password: old_password,
      password: password,
      password_confirmation: password_confirmation,
    };
    const { data } = await AuthBackend.post(`/change-password`, changePasswordData);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Update creative name
 * @async renameCreative
 * @param {array} details - creative id,creative name
 * @return {Promise<object>}
 */

export const renameCreative = async (details) => {
  try {
    const { data } = await AuthBackend.put(`/rename-creative`, details);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/* Get creatives shared with me
 * @async getSharedCreatives
 * @returns {Promise<object>}
 */

export const getSharedCreatives = async (page = 1, search) => {
  try {
    const { data } = await AuthBackend.get(
      `/shared-creatives?page=${page}&q=${search}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/* Delete creative shared user
 * @async deleteSharedUser
 * @param {number} userId - user id
 *  @param {number} creativeId - user id
 * @return {Promise<object>}
 */

export const deleteSharedUser = async (creativeId, userId) => {
  try {
    const { data } = await AuthBackend.delete(
      `creative/${creativeId}/share?userId=${userId}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/* Get deleted (moved to trash) creatives list
 * @async getTrashedCreatives
 * @returns {Promise<object>}
 */

export const getTrashedCreatives = async (page = 1, search) => {
  try {
    const { data } = await AuthBackend.get(
      `/trashed-creative?page=${page}&q=${search}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Restore the deleted creative
 * @async restoreCreative
 * @returns {Promise<object>}
 */

export const restoreCreative = async (creativeId) => {
  try {
    const { data } = await AuthBackend.post(`/trash-restore`, { creativeId });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Delete the creative permanently
 * @async deleteCreativePermanently
 * @returns {Promise<object>}
 */

export const deleteCreativePermanently = async (creativeId) => {
  try {
    const { data } = await AuthBackend.delete(
      `/trashed-creative/${creativeId}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Delete the creative (move to trash)
 * @async deleteCreative
 * @returns {Promise<object>}
 */

export const deleteCreative = async (creativeId) => {
  try {
    const { data } = await AuthBackend.delete(`/creative/${creativeId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Delete multiple creatives
 * @async deleteCreatives
 * @param {Array<string>} creativeIds
 * @returns {Promise<object>}
 */
export const deleteCreatives = async (creativeIds) => {
  try {
    const { data } = await AuthBackend.post(`/delete-multiple-creatives`, {
      creativeIds
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
export const unpublishCreative = async (creativeId) => {
  try {
    const { data } = await AuthBackend.post(`/creative/unpublish`, { 
      creativeId: creativeId 
    });
    return data;
  } catch (err) {
    console.log("Error unpublishing creative:", err);
    throw handleError(err);
  }
};
/**
 * Get all platforms
 * @async getAllPlatforms
 * @returns {Promise<object>}
 */

export const getAllPlatforms = async () => {
  try {
    const { data } = await AuthBackend.get(`template-platform-list`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get all template types
 * @async getAllTemplateTypes
 * @returns {Promise<object>}
 */

export const getAllTemplateTypes = async (withAll=true) => {
  try {
    const { data } = await AuthBackend.get(`template-type-list?withAll=${withAll}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get all template catgories
 * @async getAllTemplateCategories
 * @returns {Promise<object>}
 */

export const getAllTemplateCategories = async () => {
  try {
    const { data } = await AuthBackend.get(`template-category-list`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get all template based on catgory id
 * @async getTemplateByCategory
 * @returns {Promise<object>}
 */

export const getTemplateByCategory = async (
  categoryId,
  pageNo,
  search,
  typeId,
  platformId,
  width,
  height,
  ispaginate,
  isCustom = false
) => {
  try {
    const { data } = await AuthBackend.get('template-list', {
      params: {
        categoryId,
        page: pageNo,
        q: search,
        typeId,
        platformId,
        width,
        height,
        ispaginate,
        isCustom,
      },
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// get All templates by category


export const getAllTemplateByCategory = async (
  category = '',
  dimension = '',
  widgetId = '',
  search = '',
  adType = '',
  limit = 10,
  ispaginate = 0,
  page = 1,
  isCustom = false
) => {
  try {
    const { data } = await AuthBackend.get('template-list', {
      params: {
        category,
        dimension,
        widgetId,
        ispaginate,
        q: search,
        adType,
        limit,
        page,
        isCustom,
      },
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// get template by custom
export const getAllTemplateByCustom = async (
  category = '',
  dimension = '',
  widgetId = '',
  search = '',
  adType = '',
  limit = 10,
  ispaginate = 0,
  page = 1
) => {
  try {
    const { data } = await AuthBackend.get('template-list', {
      params: {
        category,
        dimension,
        widgetId,
        ispaginate,
        q: search,
        adType,
        limit,
        page,
        isCustom: true,
      },
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**
 * Get creative analytics details
 * @async getCreativeAnalytics
 * @returns {Promise<object>}
 */

export const getCreativeAnalytics = async (creativeId, startDate, endDate) => {
  try {
    const { data } = await AuthBackend.get(
      `creative-analytics-data?creativeId=${creativeId}&startDate=${startDate}&endDate=${endDate}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
export const getCreativeHourlyBreakDownImpressions = async (
  creativeId,
  dateSelected
) => {
  try {
    const { data } = await AuthBackend.get(
      `creative-hourly-breakdown-by-date?creativeId=${creativeId}&fromDate=${dateSelected}&toDate=${dateSelected}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

// Delete custom templates

export const deleteCustomTemplatesAPI = async (id) => {
  try {
    const { data } = await AuthBackend.delete(`delete-custom-template/${id}`);
    return data
  } catch (error) {
    throw handleError(error);
  }
}

// Update template
export const updateTemplate = async (id, name) => {
  try {
    const { data } = await AuthBackend.put(`template/${id}`, name);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}

export const getCreativeDailySummary = async (
  creativeId,
  pageNo,
  limit,
  timezone,
  startDate
) => {
  try {
    const { data } = await AuthBackend.get(
      `creative-daily-summary?creativeId=${creativeId}&startDate=${startDate}&endDate=${startDate}&tz=${timezone}&offsetBy=${pageNo}&limitBy=${limit}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get placements analytics details
 * @async getPlacementAnalytics
 * @returns {Promise<object>}
 */

export const getPlacementAnalytics = async (
  placementId,
  startDate,
  endDate
) => {
  try {
    const { data } = await AuthBackend.get(
      `placement-analytics-data?placementId=${placementId}&startDate=${startDate}&endDate=${endDate}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
export const getHourlyCampaignAnalytics_v2 = async (
  campaign, 
  day, 
  timezone,
  startTime, 
  endTime
) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/campaign/${campaign}/hourly-data?day=${day}&tzOffset=${timezone}&startTime=${startTime}&endTime=${endTime}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
export const getHourlyCreativeAnalytics_v2 = async (
  creative, 
  day, 
  timezone,
  startTime, 
  endTime
) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/creative/${creative}/hourly-data?day=${day}&tzOffset=${timezone}&startTime=${startTime}&endTime=${endTime}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const exportHourlyAnalytics = async (
  uniqueId, 
  tzOffset,
  day,
  startTime, 
  endTime,
  type,
  filters
) => {
  try {
    const filtersQuery = Array.isArray(filters) && filters.length > 0
      ? `&${filters.map((filter) => `filters[]=${encodeURIComponent(filter)}`).join('&')}`
      : '';
    const { data } = await AuthBackend.get(
      `analytics/export-hourly-data/${uniqueId}?tzOffset=${tzOffset}&startTime=${startTime}&endTime=${endTime}&day=${day}&type=${type}${filtersQuery}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const exportFullEventList = async (
  uniqueId, 
  tz,
  startDateTime, 
  endDateTime,
  type,
  filters
) => {
  try {
    const filtersQuery = Array.isArray(filters) && filters.length > 0
      ? `&${filters.map((filter) => `filters[]=${encodeURIComponent(filter)}`).join('&')}`
      : '';
    const { data } = await AuthBackend.get(
      `analytics/export-event-list/${uniqueId}?tzOffset=${tz}&start=${startDateTime}&end=${endDateTime}&type=${type}${filtersQuery}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const exportReferralData = async (
  uniqueId,
  tzOffset,
  startDateTime,
  endDateTime,
  type,
  metric
) => {
  try {
    const metricQuery = metric ? `&metric=${encodeURIComponent(metric)}` : "";
    const { data } = await AuthBackend.get(
      `analytics/export-referral-data/${uniqueId}?tzOffset=${tzOffset}&start=${startDateTime}&end=${endDateTime}&type=${type}${metricQuery}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const exportHourlyImpressionData = async (
  uniqueId,
  tzOffset,
  startDateTime,
  endDateTime,
  type
) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/export-hourly-impression-data/${uniqueId}?tzOffset=${tzOffset}&start=${startDateTime}&end=${endDateTime}&type=${type}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const exportFormSubmissions = async (
  uniqueId,
  tzOffset,
  startDateTime,
  endDateTime,
  type,
) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/export-form-submissions/${uniqueId}?tzOffset=${tzOffset}&start=${startDateTime}&end=${endDateTime}&type=${type}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getConversationFlowSummary = async (
  creativeId,
  tzOffset,
  startDateTime,
  endDateTime,
) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/creatives/${creativeId}/conversation-flow?tz_offset=${tzOffset}&start=${startDateTime}&end=${endDateTime}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getPlacementConversationFlowSummary = async (
  placementId,
  tzOffset,
  startDateTime,
  endDateTime,
) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/placements/${placementId}/conversation-flow?tz_offset=${tzOffset}&start=${startDateTime}&end=${endDateTime}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getCampaignConversationFlowSummary = async (
  campaignId,
  tzOffset,
  startDateTime,
  endDateTime,
) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/campaigns/${campaignId}/conversation-flow?tz_offset=${tzOffset}&start=${startDateTime}&end=${endDateTime}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getHourlyPlacementAnalytics_v2 = async (
  placement, 
  day, 
  timezone,
  startTime, 
  endTime
) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/placement/${placement}/hourly-data?day=${day}&tzOffset=${timezone}&startTime=${startTime}&endTime=${endTime}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
export const getHourlyBreakDownImpressions = async (
  placementId,
  dateSelected
) => {
  try {
    const { data } = await AuthBackend.get(
      `placement-hourly-breakdown-by-date?placementId=${placementId}&fromDate=${dateSelected}&toDate=${dateSelected}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
export const getDailySummary = async (
  placementId,
  pageNo,
  limit,
  timezone,
  startDate
) => {
  try {
    const { data } = await AuthBackend.get(
      `placement-daily-summary?placementId=${placementId}&startDate=${startDate}&endDate=${startDate}&tz=${timezone}&offsetBy=${pageNo}&limitBy=${limit}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getPlacementAdtype = async (placementId) => {
  const { data } = await AuthBackend.get(`get-placement-adtype/${placementId}`);
  return data.data;
};

export const exportTemplate = async (templateData) => {
  try {
    const { data } = await AuthBackend.post("template-export", templateData);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**
 * Get creative assets
 * @async getCreativeAssets
 * @returns {Promise<object>}
 */

export const getCreativeAssets = async (creativeid, filetype, search='') => {
  try {
    const { data } = await AuthBackend.get(
      `/assets-by-creative/${creativeid}?type=${filetype}&q=${search}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Delete asset by id
 * @async deleteCreativeAsset
 * @param {number} id - asset id
 * @return {Promise<object>}
 */

export const deleteCreativeAsset = async (id) => {
  try {
    const { data } = await AuthBackend.delete(`asset/${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


export const detachCreativeAsset = async (id, assetIds) => {
  try {
    const { data } = await AuthBackend.post(`creative/${id}/assets `, {
      assetIds
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * update asset by id
 * @async updateCreativeAsset
 * @param {number} id - asset id
 * @return {Promise<object>}
 */

export const updateCreativeAsset = async (id, updateValue) => {
  try {
    const { data } = await AuthBackend.put(`asset/${id}`, updateValue);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * replace asset by id
 * @async replaceCreativeAsset
 * @param {number} oldId - old asset id
 * @param {number} newId - new asset id
 * @return {Promise<object>}
 */

export const replaceCreativeAsset = async (oldId, newId) => {
  try {
    const { data } = await AuthBackend.post(`asset-replace`, {
      oldId,
      newId
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get creative versions
 * @async getCreativeVersions
 * @returns {Promise<object>}
 */

export const getCreativeVersions = async (creativeid) => {
  try {
    const { data } = await AuthBackend.get(
      `/creative-versions/${creativeid}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get creative version data
 * @async getVersionData
 * @returns {Promise<object>}
 */

export const getVersionData = async (creativeid, version) => {
  try {
    const { data } = await AuthBackend.get(
      `/creative-version/${creativeid}/${version}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const restoreCreativeVersion = async (creativeid, version) => {
  try {
    const { data } = await AuthBackend.post(
      `/creative-version/${creativeid}/${version}/restore`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};








// ------------------------------------- Analytics API ------------------------------------------


/**
 * Get Campaign Analytics
 * @async getCampaignAnalyticsSummary_v2
 * @param {number} campaignId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} basematric - base matric
 * @returns {Promise<object>}
 */

export const getCampaignAnalyticsSummary_v2 = async (campaignId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/campaign/${campaignId}/summary?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Share Settings list for Campaign Analytics
 * @async getAnalyticsShareSettings
 * @returns {Promise<object>}
 */
export const getAnalyticsShareSettings = async (type, id,token) => {
  try {
    const { data } = await AuthBackend.get(`analytics/settings?type=${type}&id=${id}&token=${token}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Exchange analytics share token to scoped bearer token.
 * This sets the bearer token on AuthBackend for subsequent analytics calls.
 */
export const exchangeAnalyticsShareToken = async (token) => {
  try {
    const { data } = await AuthBackend.post(`analytics/share/exchange`, { token });
    const accessToken = data?.data?.access_token;
    if (accessToken) {
      AuthBackend.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    }
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get Campaign Data Analytics
 * @async getCampaignAnalyticsData_v2
 * @param {number} campaignId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @returns {Promise<object>}
 */

export const getCampaignAnalyticsData_v2 = async (campaignId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/campaign/${campaignId}/data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Campaign Data Analytics
 * @async getCampaignAnalyticsTypeData
 * @param {string} type - type of analytics
 * @param {number} campaignId - campaign id
 * @param {string} start - start date/time
 * @param {string} end - end date/time
 * @param {string} timezone - timezone offset
 * @param {string} limit - page size
 * @param {string} page - page number
 * @param {array} selectedComponentIds - selected component ids
 * @returns {Promise<object>}
 */

/**
 * Purpose-specific analytics API (preferred). Typed ?type= remains as fallback.
 */
const analyticsPurposePath = (scope, id, purpose) => `analytics/${scope}/${id}/${purpose}`;

const buildAnalyticsQuery = ({ start, end, timezone, limit = 7, page = 1, selectedComponentIds = [], metric = null, displayTimezone = null, includeCatalog = null }) => {
  const filters = Array.isArray(selectedComponentIds) && selectedComponentIds.length
    ? `&${selectedComponentIds.map(componentId => `filters[]=${encodeURIComponent(componentId)}`).join('&')}`
    : '';
  const metricParam = metric ? `&metric=${metric}` : '';
  const displayTz = displayTimezone ? `&display_timezone=${encodeURIComponent(displayTimezone)}` : '';
  const catalogParam = includeCatalog === null ? '' : `&include_catalog=${includeCatalog ? 1 : 0}`;
  return `tz_offset=${timezone}&start=${start}&end=${end}&limit=${limit}&page=${page}${filters}${metricParam}${displayTz}${catalogParam}`;
};

const typeToPurpose = {
  summary: 'summary',
  graph: 'timeseries',
  'full-event': 'events',
  'hourly-aggregate': 'hourly-matrix',
  'referral-summary': 'referrals',
  'form-handler': 'forms',
  'widget-dimension': 'widgets',
};

const adaptPurposeResponse = (type, payload) => {
  if (!payload) return payload;
  if (type === 'summary') {
    return {
      summary: payload.summary ?? payload.metrics ?? payload,
      metrics: payload.metrics,
    };
  }
  if (type === 'graph') {
    // Prefer nested GraphAnalytics shape { config, data: { xaxis, Impression, ... } }
    // that SingleGraph / CompareGraph already consume.
    const nested = payload?.data && (payload.data.xaxis || payload.data.Impression)
      ? payload.data
      : null;
    const graph = nested || {
      xaxis: payload.xaxis ?? (payload.series || []).map((p) => p.timestamp),
      Impression: payload.Impression ?? (payload.series || []).map((p) => p.impressions ?? 0),
      View: payload.View ?? (payload.series || []).map((p) => p.views ?? 0),
      Click: payload.Click ?? (payload.series || []).map((p) => p.clicks ?? 0),
    };
    return {
      config: payload.config ?? {
        availableDataPoints: ['Impression', 'Click'],
        defaultSelectedPoints: ['Impression', 'Click'],
      },
      data: graph,
      // Flat aliases for any callers that read top-level fields.
      ...graph,
      series: payload.series,
      grain: payload.grain,
    };
  }
  return payload;
};

export const getAnalyticsPurposeData = async (scope, id, purpose, params = {}) => {
  try {
    const query = buildAnalyticsQuery(params);
    const { data } = await AuthBackend.get(`${analyticsPurposePath(scope, id, purpose)}?${query}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getAnalyticsBootstrap = async (scope, id, params = {}) => {
  return getAnalyticsPurposeData(scope, id, 'bootstrap', params);
};

export const getCampaignAnalyticsTypeData = async (type, campaignId, start = null, end = null, timezone, limit = 7, page = 1, selectedComponentIds = [], metric = null, displayTimezone = null) => {
  try {
    const purpose = typeToPurpose[type];
    if (purpose) {
      const envelope = await getAnalyticsPurposeData('campaigns', campaignId, purpose, {
        start, end, timezone, limit, page, selectedComponentIds, metric, displayTimezone,
        includeCatalog: type === 'full-event' ? page === 1 : null,
      });
      const body = envelope?.data ?? envelope;
      return { ...envelope, data: adaptPurposeResponse(type, body) };
    }
    const filters = Array.isArray(selectedComponentIds) && selectedComponentIds.length
      ? `&${selectedComponentIds.map(componentId => `filters[]=${componentId}`).join('&')}`
      : '';
    const metricParam = metric ? `&metric=${metric}` : '';
    const displayTz = displayTimezone ? `&display_timezone=${encodeURIComponent(displayTimezone)}` : '';
    const { data } = await AuthBackend.get(`campaign/${campaignId}/analytics?type=${type}&tz_offset=${timezone}&start=${start}&end=${end}&limit=${limit}&page=${page}${filters}${metricParam}${displayTz}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**
 * Get Creative Data Analytics
 * @async getCreativeAnalyticsTypeData
 * @param {string} type - type of analytics
 * @param {number} creativeId - creative id
 * @param {string} start - start date/time
 * @param {string} end - end date/time
 * @param {string} timezone - timezone offset
 * @param {string} limit - page size
 * @param {string} page - page number
 * @param {array} selectedComponentIds - selected component ids
 * @returns {Promise<object>}
 */

export const getCreativeAnalyticsTypeData = async (type, creativeId, start = null, end = null, timezone, limit = 7, page = 1, selectedComponentIds = [], metric = null, displayTimezone = null) => {
  try {
    const purpose = typeToPurpose[type];
    if (purpose) {
      const envelope = await getAnalyticsPurposeData('creatives', creativeId, purpose, {
        start, end, timezone, limit, page, selectedComponentIds, metric, displayTimezone,
        includeCatalog: type === 'full-event' ? page === 1 : null,
      });
      const body = envelope?.data ?? envelope;
      return { ...envelope, data: adaptPurposeResponse(type, body) };
    }
    const filters = Array.isArray(selectedComponentIds) && selectedComponentIds.length
      ? `&${selectedComponentIds.map(componentId => `filters[]=${encodeURIComponent(componentId)}`).join('&')}`
      : '';
    const metricParam = metric ? `&metric=${metric}` : '';
    const displayTz = displayTimezone ? `&display_timezone=${encodeURIComponent(displayTimezone)}` : '';
    const { data } = await AuthBackend.get(`creative/${creativeId}/analytics?type=${type}&tz_offset=${timezone}&start=${start}&end=${end}&limit=${limit}&page=${page}${filters}${metricParam}${displayTz}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Placement Data Analytics
 * @async getPlacementAnalyticsTypeData
 * @param {string} type - type of analytics
 * @param {number} placementId - placement id
 * @param {string} start - start date/time
 * @param {string} end - end date/time
 * @param {string} timezone - timezone offset
 * @param {string} limit - page size
 * @param {string} page - page number
 * @param {array} selectedComponentIds - selected component ids
 * @returns {Promise<object>}
 */

export const getPlacementAnalyticsTypeData = async (type, placementId, start = null, end = null, timezone, limit = 7, page = 1, selectedComponentIds = [], metric = null, displayTimezone = null) => {
  try {
    const purpose = typeToPurpose[type];
    if (purpose) {
      const envelope = await getAnalyticsPurposeData('placements', placementId, purpose, {
        start, end, timezone, limit, page, selectedComponentIds, metric, displayTimezone,
        includeCatalog: type === 'full-event' ? page === 1 : null,
      });
      const body = envelope?.data ?? envelope;
      return { ...envelope, data: adaptPurposeResponse(type, body) };
    }
    const filters = Array.isArray(selectedComponentIds) && selectedComponentIds.length
      ? `&${selectedComponentIds.map(componentId => `filters[]=${componentId}`).join('&')}`
      : '';
    const metricParam = metric ? `&metric=${metric}` : '';
    const displayTz = displayTimezone ? `&display_timezone=${encodeURIComponent(displayTimezone)}` : '';
    const { data } = await AuthBackend.get(`placement/${placementId}/analytics?type=${type}&tz_offset=${timezone}&start=${start}&end=${end}&limit=${limit}&page=${page}${filters}${metricParam}${displayTz}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Campaign Data Analytics
 * @async getCampaignCompareData_v2
 * @param {number} campaignId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @returns {Promise<object>}
 */
export const getCampaignCompareData_v2 = async (campaignId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/campaign/${campaignId}/graph-data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Campaign Referral Data Analytics
 * @async getCampaignReferralData_v2
 * @param {number} campaignId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} timezone - timezone offset
 * @returns {Promise<object>}
 */
export const getCampaignReferralData_v2 = async (campaignId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/campaign/${campaignId}/referral-data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Campaign Hourly Graph Data Analytics
 * @async getCampaignHourlyGraphData_v2
 * @param {number} campaignId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} timezone - timezone offset
 * @returns {Promise<object>}
 */
export const getCampaignHourlyGraphData_v2 = async (campaign, day, timezone, startTime, endTime) => {
  try {
    const { data } = await AuthBackend.get(`analytics/campaign/${campaign}/hourly-graph-data?day=${day}&tzOffset=${timezone}&startTime=${startTime}&endTime=${endTime}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get Creative Data Analytics
 * @async getCreativeAnalyticsData_v2
 * @param {number} creativeId - creative id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @returns {Promise<object>}
 */

export const getCreativeAnalyticsData_v2 = async (creativeId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/creative/${creativeId}/data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get Placement Data Analytics
 * @async getCampaignAnalytics_v2
 * @param {number} placementId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @returns {Promise<object>}
 */

export const getPlacementAnalyticsData_v2 = async (placementId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/placement/${placementId}/data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Creative Referral Data
 * @async getPlacementReferralData_v2
 * @param {number} placementId - placement id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} timezone - timezone offset
 * @returns {Promise<object>}
 */ 
export const getPlacementReferralData_v2 = async (placementId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/placement/${placementId}/referral-data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Campaign Data Analytics
 * @async getPlacementCompareData_v2
 * @param {number} placementId - placement id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @returns {Promise<object>}
 */
export const getPlacementCompareData_v2 = async (placementId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/placement/${placementId}/graph-data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Placement Hourly Graph Data Analytics
 * @async getPlacementHourlyGraphData_v2
 * @param {number} placementId - placement id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} timezone - timezone offset
 * @returns {Promise<object>}
 */
export const getPlacementHourlyGraphData_v2 = async (placement, day, timezone, startTime, endTime) => {
  try {
    const { data } = await AuthBackend.get(`analytics/placement/${placement}/hourly-graph-data?day=${day}&tzOffset=${timezone}&startTime=${startTime}&endTime=${endTime}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Placement Analytics
 * @async getPlacementAnalytics_v2
 * @param {number} placementId - placement id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} basematric - base matric
 * @returns {Promise<object>}
 */

export const getPlacementAnalytics_v2 = async (placementId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/placement/${placementId}/summary?start=${startDate}&end=${endDate}&tzOffset=${timezone}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Creative Analytics
 * @async getCreativeAnalytics_v2
 * @param {number} creativeId - creative id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} basematric - base matric
 * @returns {Promise<object>}
 */

export const getCreativeAnalytics_v2 = async (creativeId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(
      `analytics/creative/${creativeId}/summary?start=${startDate}&end=${endDate}&tzOffset=${timezone}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Creative Referral Data
 * @async getCreativeReferralData_v2
 * @param {number} creativeId - creative id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} timezone - timezone offset
 * @returns {Promise<object>}
 */
export const getCreativeReferralData_v2 = async (creativeId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/creative/${creativeId}/referral-data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Campaign Data Analytics
 * @async getCampaignCompareData_v2
 * @param {number} campaignId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @returns {Promise<object>}
 */
export const getCreativeCompareData_v2 = async (creativeId, startDate, endDate, timezone) => {
  try {
    const { data } = await AuthBackend.get(`analytics/creative/${creativeId}/graph-data?tzOffset=${timezone}&start=${startDate}&end=${endDate}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Campaign Hourly Graph Data Analytics
 * @async getCampaignHourlyGraphData_v2
 * @param {number} campaignId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} timezone - timezone offset
 * @returns {Promise<object>}
 */
export const getCreativeHourlyGraphData_v2 = async (creative, day, timezone, startTime, endTime) => {
  try {
    const { data } = await AuthBackend.get(`analytics/creative/${creative}/hourly-graph-data?day=${day}&tzOffset=${timezone}&startTime=${startTime}&endTime=${endTime}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

/**
 * Get Campaign Creatives for Analytics
 * @async getCampaignCreatives_v2
 * @param {number} campaignId - campaign id
 * @param {string} startDate - start date
 * @param {string} endDate - end date
 * @param {string} basematric - base matric
 * @param {string} page - page number
 * @param {string} search - search string
 * @param {string} adType - ad type
 * @returns {Promise<object>}
 */

export const getCampaignCreatives_v2 = async (campaignId, startDate, endDate, page, search, adType, timezone) => {
  try {
    const { data } = await AuthBackend.get(
      `campaign/${campaignId}/creatives?start=${startDate}&end=${endDate}&page=${page}&q=${search}&adType=${adType}&tzOffset=${timezone}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**
 * Media Transcoding API
 * @param {number} assetId 
 */
export const setMediaTranscoding = (assetId, accessId = null, assetFolderId = null, brandKitId) => {
  try {
    const { data } = AuthBackend.get(`transcoding-media?assetId=${assetId}&accessId=${accessId}&assetFolderId=${assetFolderId}&brandKitId=${brandKitId}`);
    console.log(data);
  } catch (err) {
    throw handleError(err);
  }
}

/**
 * Api to get token for image optimization
 * @param {string} key
 * @param {string} canvasWidth
 * @param {string} canvasHeight
 * @param {string} eventName
 * @param {string} domain
 * @param {string} userId
 * @param {string} broadcastChannel
 * 
 */
export const getImageOptimizationToken = async (key, canvasWidth, canvasHeight, eventName, domain, userId, broadcastChannel) => {
  try {
    const { data } = await AuthBackend.post(`auth/generate-jwt-token`, {
      key,
      canvasWidth,
      canvasHeight,
      eventName,
      domain,
      userId,
      broadcastChannel
    });

    return data;
  } catch (err) {
    throw handleError(err);
  }
}

/**
   DELETE Multiple Numbers of placements by
   List of Placement Id's ( POST)
 */

  export const deletePlacements = async (placementIds) => {
    try {
      const { data } = await AuthBackend.post(
        `/delete-multiple-placements`,
        {
          placementIds
        }
      );
      return data;
    } catch (err) {
      throw handleError(err);
    }
  };


export const generateJwtToken = async (key, canvasWidth, canvasHeight, eventName, domain, userId, broadcastChannel, url) => {
  try {
    const { data } = await AuthBackend.post(`auth/generate-jwt-token`, {
      key,
      canvasWidth,
      canvasHeight,
      eventName,
      domain,
      userId,
      broadcastChannel,
      url
    });

    return data;
  } catch (err) {
    throw handleError(err);
  }
}

export const storeCreativeExitUrl = async (creativeId, exitUrls) => {
  try {
    const { data } = await AuthBackend.post(`store-creative-exit-url`, {
      creativeId,
      exitUrls
    });

    return data;
  } catch (err) {
    throw handleError(err);
  }
}

export const setPrimaryVideo = async (asset, creativeId, isPrimary) => {
  try {
    const { data } = await AuthBackend.post(`set-primary-video`, {
      asset,
      creativeId,
      isPrimary
    });
    return data;
  }
  catch (err) {
    throw handleError(err);
  }
}


/**
 * Send preview link via email
 * @async sendPreviewLink
 * @param {number} creativeId - creative id
 * @param {array} emails - list of emails
 * @param {string} url - url
 * @param {string} name - Creative name
 * @returns {Promise<object>}
 */
export const sendPreviewLink = async (creativeId, emails, url, name) => {
  try {
    const { data } = await AuthBackend.post(`public-preview/${creativeId}/share-via-email`, {
      to: emails,
      url,
      name
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const generateAdTags = async (creativeId, placementId, macros) => {
  try {
    const endpoint = placementId
      ? `placements/${encodeURIComponent(placementId)}/tags`
      : `generate-tags-url`;
    const { data } = await AuthBackend.post(endpoint, {
      creative_id: creativeId,
      macros
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * 
 * @param {number} creativeId - creative id
 * @param {string} name -folder name
 * @returns {Promise<object>}
 */

export const createAssetFolder = async (parentId,type,name) => {
  try {
    const { data } = await AuthBackend.post(`asset-folder`, {
      parentId,
      type,
      name
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
/**
 * update asset folder by id
 * @async updateAssetFolder
 * @param {number} id - asset id
 * @return {Promise<object>}
 */

export const updateAssetFolder = async (id, updateValue) => {
  try {
    const { data } = await AuthBackend.put(`asset-folder/${id}`, updateValue);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
/**
 * Get asset folder by id
 * @async getAssetFolder
 * @param {number} id - asset id
 * @return {Promise<object>}
 */
export const deleteAssetFolder = async (id ) => {
  try {
    const { data } = await AuthBackend.delete(`asset-folder/${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const attachAssetToFolder = async (assetId,folderId,creativeId) => {
  try {
    const { data } = await AuthBackend.post(`add-asset-to-folder`, {
      assetId,
      folderId,
      creativeId
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


// Get folder data

export const getFolderData = async (brandkitid, type, search, page) => {
  try {
    const { data } = await AuthBackend.get(
      `asset?assetFolderId[0]=${brandkitid}&type=${type}&q=${search}&page=${page}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



/**
 
   GET ALL CREATIVE"S FROM CAMPAIGN UNIQUE_ID

 */

export const getAllCreativeByCampaignId = async (uniqueId) => {

    try {

      const {data} = await AuthBackend.get(`campaign/creatives/${uniqueId}`);
      return data;

    } catch (error) {

      throw error;

    }
}



/**
 
   GET ALL PLACEMENT"S FROM CAMPAIGN UNIQUE_ID

 */

export const getAllPlacementByCampaignId = async (uniqueId, sort, search = '', order='desc') => {

    try {
  
      const {data} = await AuthBackend.get(`campaign/placements/${uniqueId}?sort=${sort}&q=${search}&order=${order}`);
      return data;
  
    } catch (error) {
  
      throw error;
  
    }
}


// GET ALL placement bu creative id
export const getAllPlacementByCreativeId = async (uniqueId, sort, search = '', order='desc', creativeId) => {

  try {
// &creativeId=${creativeId}
    const {data} = await AuthBackend.get(`creative/placements/${creativeId}?sort=${sort}&q=${search}&order=${order}`);
    return data;

  } catch (error) {

    throw error;

  }
}

/**
 * CREATE A BRAND KIT FOLDER
 * 
 */

export const createBrandKitFolder = async (name, type) => {
  try {
    const { data } = await AuthBackend.post(`asset-folder`, {
      name,
      type
    });

    return data;
    
  } catch (error) {
    throw error;
  }
}

/**
 * 
 * List Brand Kit & Folders
 * 
 */


export const getBrandKitAndFolder = async (search, sort, order, limit, page) => {

  try {

    const {data} = await AuthBackend.get(`asset-folder?type[0]=brand_kit_folder&type[1]=brand_kit&q=${search}&sort=${sort}&order=${order}&page=${page}&limit=${limit}`);
    return data;

  } catch (error) {

    throw error;

  }
}


/**
 * 
 * Rename BrandKit Folder
 * 
 */


export const renameBrandKitFolder = async (name, id, accessId, brandKitId) => {
  try {
    const { data } = await AuthBackend.put(`asset-folder/${id}`, {
      name,
      accessId,
      brandKitId
    });
    return data;
  } catch (error) {
    throw error;
    
  }
}

/**
 * 
 * Upload color palatte into Brandkit 
 * 
 */

export const uploadBrandKitColor = async (colors, id, accessId = null) => {
  try {
    const { data } = await AuthBackend.put(`asset-folder/${id}`, {
      colors, accessId
    });
    return data;
  } catch (error) {
    throw error;
    
  }
}

/**
 * 
 * DELETE BrandKIT Folder Delete
 * 
 */

export const deleteBrandKitFolder = async (id) => {
  try {
    const { data } = await AuthBackend.delete(`asset-folder/${id}`);
    return data;
  } catch (error) {
    throw error;
    
  }
}


/**
 * get Brandkit details by id
 * 
 */


export const getBrandKitDetails = async (id, type = 'logo', page, search,accessId) => {

  try {

    const {data} = await AuthBackend.get(`asset-folder/${id}?type=${type}&page=${page}&accessId=${accessId}&q=${search}`);
    return data;

  } catch (error) {

    throw error;

  }
}

/**
 * 
 * UPLoad Brand Kit asset
 * 
 */

export const uploadBrandKitAsset = async (creativeId, userId, fileType, name, mimetype, assetId, assetFolderId, accessId = null) => {
  const { data } = await AuthBackend.post("asset-upload-request-signed-url", {
    creativeId, userId, fileType, name, mimetype, assetId, assetFolderId, accessId, brandKitId: assetFolderId
  });
  return data.data;
}

/**
 * 
 * ADD Font style URL BrandKit
 * 
 */

export const uploadBrandKitFontStyleURL = async (fontStyles, id) => {
  try {
    const { data } = await AuthBackend.put(`asset-folder/${id}`, {
      fontStyles
    });
    return data;
  } catch (error) {
    throw error;
    
  }
}


/**
 * 
 * Delete Brandkit Properties
 * 
 */

export const deleteBrandKitProperties = async (assetId, brandkitId, assetType, accessId = null, brandKitId) => {
  try {
    const { data } = await AuthBackend.post(`remove-asset-from-brandkit`, {
      assetId:[assetId],assetFolderId: brandkitId, assetType, accessId, brandKitId


    });
    return data;
  } catch (error) {
    throw error;
    
  }
}


/**
 * 
 * Delete BrandkitFont Style properties
 * 
 */

export const deleteBrandKitFontProperties = async (assetId, brandkitId, assetType, fontId) => {
  try {
    const { data } = await AuthBackend.post(`remove-asset-from-brandkit`, {
      assetId, brandkitId, assetType, fontId
    });
    return data;
  } catch (error) {
    throw error;
    
  }
}


/**
 * 
 * Delete Brand Kit Color
 * 
 */
export const deleteBrandKitColors = async (assetId, brandkitId, assetType, colors) => {
  try {
    const { data } = await AuthBackend.post(`remove-asset-from-brandkit`, {
      assetId, brandkitId, assetType, colors
    });
    return data;
  } catch (error) {
    throw error;
    
  }
}



/**
 * 
 * Transfer BrandKit into Foldser
 * 
 */

export const transferBrandKitIntoFolder = async (brandkitId , folderName) => {
  try {
    const { data } = await AuthBackend.post(`move-brandkit-to-folder`, {
      brandkitId , folderName
    });
    return data;
  } catch (error) {
    throw error;
    
  }
}



/**
 * GET BrandKit By Folder wise
 * 
 * 
 */

export const getBrandKitsByFolder = async (folderId, search,  page) => {

  try {

    const {data} = await AuthBackend.get(`asset-folder?type[0]=brand_kit&parentId=${folderId}&q=${search}&page=${page}`);
    return data;

  } catch (error) {

    throw error;

  }
}


/**
 * 
 * Create A Brand Kit Inside The Folder
 * 
 */

export const createBrandKitInsideTheFolder = async (name, type, parentId) => {
  try {
    const { data } = await AuthBackend.post(`asset-folder`, {
      name,
      type,
      parentId
    });

    return data;
    
  } catch (error) {
    throw error;
  }
}


/**
 * 
 * Transfer Branfd kit out of folder
 * 
 */

export const transferBrandKitInroOutOfFolder = async (brandkitId) => {
  try {
    const { data } = await AuthBackend.post(`remove-brandkit-from-folder`, {
      brandkitId
    });

    return data;
    
  } catch (error) {
    throw error;
  }
}


/**
 * 
 * GET Folder's By search
 * 
 * 
 */

export const getFoldersList = async (search) => {

  try {

    const {data} = await AuthBackend.get(`/asset-folder?type[0]=brand_kit_folder&q=${search}&paginate=0`);
    return data;

  } catch (error) {

    throw error;

  }
}



// Download ALl Campaign analytics Report

export const getAllCampaignAnalyticsReport = async (campaignId, startDate, endDate, timezone, baseMetrics) => {

  try {

    const {data} = await AuthBackend.get(`analytics/export-campaign-analytics/${campaignId}?start=${startDate}&end=${endDate}&tzOffset=${timezone}&baseMetrics=${baseMetrics}`);
    return data;

  } catch (error) {

    throw error;

  }
}






// Download ALl Placement analytics Report

export const getAllPlacementAnalyticsReport = async (placementId, startDate, endDate, timezone, baseMetrics) => {

  try {

    const {data} = await AuthBackend.get(`analytics/export-placement-analytics/${placementId}?start=${startDate}&end=${endDate}&tzOffset=${timezone}&baseMetrics=${baseMetrics}`);
    return data;

  } catch (error) {

    throw error;

  }
}



// Download ALl Creative analytics Report

export const getAllCreativeAnalyticsReport = async (creativeId, startDate, endDate, timezone, baseMetrics) => {

  try {

    const {data} = await AuthBackend.get(`analytics/export-creative-analytics/${creativeId}?start=${startDate}&end=${endDate}&tzOffset=${timezone}&baseMetrics=${baseMetrics}`);
    return data;

  } catch (error) {

    throw error;

  }
}


/**
 * 
 * Copy Brand Kit
 * 
 */

export const copyBrandKitAndFolder = async (name, brandkitId, type) => {
  try {
    const { data } = await AuthBackend.post(`copy-assetFolder`, {
      name,
      brandkitId,
      type
    });

    return data;
    
  } catch (error) {
    throw error;
  }
}

/**
 * 
 * Copy Brand Kit
 * 
 */

export const copyBrandkitFolder = async (name, folderId, type) => {
  try {
    const { data } = await AuthBackend.post(`copy-assetFolder`, {
      name,
      folderId,
      type
    });

    return data;
    
  } catch (error) {
    throw error;
  }
}

/**
 * Get Notifications
 */
export const getNotifications = async (params = undefined) => {
  try {
    // New notifications API is paginated. Pass { page, per_page, unread } from callers.
    const { data } = await AuthBackend.get(`notifications`, {
      params,
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
}
/**
 * Get unread notifications count
 */
export const getUnreadNotificationsCount = async () => {
  try {
    const { data } = await AuthBackend.get(`notifications/unread-count`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}
/**
 * Mark All notification as read
 */
export const markAllNotificationAsRead = async () => {
  try {
    const { data } = await AuthBackend.post(`notifications/read-all`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}
/**
 * Mark notification as read
 */
export const markNotificationAsRead = async (notificationId) => {
  try {
    const { data } = await AuthBackend.post(`notifications/${notificationId}/read`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}
/**
 * Delete a notification
 */
export const deleteNotification = async (notificationId) => {
  try {
    const { data } = await AuthBackend.delete(`notifications/${notificationId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}
/**
 * Clear all notifications
 */
export const clearAllNotifications = async () => {
  try {
    const { data } = await AuthBackend.delete(`notifications`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}
/**
 * Get recent searches
 */
export const getRecentSearches = async () => {
  try {
    const { data } = await AuthBackend.get(`recent-searches`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}
/**
 * Gloal search
 */
export const globalSearch = async (query) => {
  try {
    const { data } = await AuthBackend.get(`universal-search?query=${query}&filter[0]=campaigns&filter[1]=creatives&filter[2]=templates&filter[3]=brandkits&filter[4]=placements`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}

/**
 * Track the clicked result
 */
export const trackSearch = async (result) => {
  try {
    const { data } = await AuthBackend.post(`track-click`, {
      item_id :result.item_id,
      type : result.type,
      name : result.name,
      thumbnail : result.thumbnail || null,
      dimension: result.dimension || null,
      creatives_count: result.creatives_count || null
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
}

/**
 * Clear the current search history
 */
export const clearCurrentHistory = async (result) => {
  try {
    const { data } = await AuthBackend.get(`remove-recent-search/${result.id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}
export const clearAllHistory = async () => {
  try {
    const { data } = await AuthBackend.get(`clear-recent-searches`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}

// GET THE LATEST !) CREATIVES ON DASHBOARD
export const getLatestCreatives = async () => {
  try {
    const { data } = await AuthBackend.get(`creative`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}



// GET THE Analytics data on Dashboard
export const getDashboardDatas = async (timezone, displayTimezone = null) => {
  try {
    const displayTz = displayTimezone ? `&display_timezone=${encodeURIComponent(displayTimezone)}` : '';
    const { data } = await AuthBackend.get(`analytics/sevendays-summary?tzOffset=${timezone}${displayTz}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}



// GET Trending templates
export const getTrendingTemplates = async () => {
  try {
    const { data } = await AuthBackend.get(`template?ispaginate=0&limit=10`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}

export const fetchBannerDetails = async () => {
  try {
    const env = await import.meta.env;
    const { data } = await AuthBackend.get(`dashboard/get-banners?api_token=${env.VITE_APP_DASHBOARD_API_TOKEN}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
export const getAdctvWidgets = async (creativeId) => {
  try {
    const { data } = await AuthBackend.get(`/widget?creativeId=${creativeId}&type=adctv`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


//--------------------------------- V2 API --------------------------------------------

export const updateCreativeV2 = async ({
  creativeId,
  creativeVersion,
  content,
  html,
  thumbnail,
  duration,
  height,
  width,
  exitUrls,
  isResponsive
}) => {
  try {
    console.log("inside index",creativeId,
      creativeVersion,
      content,
      html,
      thumbnail,
      duration,
      height,
      width,
      exitUrls);
      /creative/id
    const { data } = await AuthBackendV2.post("/creative", {
      creativeId,
      creativeVersion,
      content,
      html,
      thumbnail,
      duration,
      height,
      width,
      exitUrls,
      isResponsive
    });
      return data;
    } catch (err) {
      throw handleError(err);
    }
  };

  export const loadCreativeV2 = async (creativeId) => {
    try {
      const { data } = await AuthBackendV2.get(`creative/${creativeId}`);
      return data;
    } catch (err) {
      throw handleError(err);
    }
  };


// GET All Trash Campaigns

export const getAllTrashedCampaigns = async (search) => {
  try {
    const { data } = await AuthBackend.get(`trashed-campaigns?q=${search}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// GET ALL Trashed Creatives
export const getAllTrashedCreatives = async (search) => {
  try {
    const { data } = await AuthBackend.get(`trashed-creatives?q=${search}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// GET ALL Trashed Brandkits
export const getAllTrashedBrandkits = async (search) => {
  try {
    const { data } = await AuthBackend.get(`trashed-brandkits?q=${search}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// DELETE Campaign Trash item
export const deleteCampaignTrashItem = async (campaignId) => {
  try {
    const { data } = await AuthBackend.delete(`destroy-campaign/${campaignId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// DELETE Creative Trash item
export const deleteCreativeTrashItem = async (creativeId) => {
  try {
    const { data } = await AuthBackend.delete(`destroy-creative/${creativeId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// DELETE Creative Trash item
export const deleteBrandkitTrashItem = async (brandkitId) => {
  try {
    const { data } = await AuthBackend.delete(`destroy-brandkit/${brandkitId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// Restore Campaign Trash item
export const restoreCampaignTrashItem = async (campaignId) => {
  try {
    const { data } = await AuthBackend.post(`restore-campaign/${campaignId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// Restore Creative Trash item
export const restoreCreativeTrashItem = async (creativeId) => {
  try {
    const { data } = await AuthBackend.post(`restore-creative/${creativeId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};




// Restore Creative Trash item
export const restoreBrandKitTrashItem = async (brandkitId) => {
  try {
    const { data } = await AuthBackend.post(`restore-brandkit/${brandkitId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// get paginated Creative List in campaigns

export const getPaginatedCreativesList = async (
  page = 1,
  campaignId,
  search,
  limit,
  sortBy,
  sortOrder,
  adType = '',
  dimension = '',
  widgetId = '',
  userId = '',
) => {
  try {
    const params = {
      campaignId,
      page,
      q: search,
      paginated: true,
      limit,
      sortBy,
      sortOrder,
    };

    if (adType) {
      params.adType = adType;
    }
    if (dimension) {
      params.dimension = dimension;
    }
    if (widgetId) {
      params.widgetId = widgetId;
    }
    if (userId) {
      params.userId = userId;
    }

    const { data } = await AuthBackend.get('creative', { params });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// get paginated Placement in  Campaign
export const getPaginatedPlacementByCampaignId = async (uniqueId, search = '', page = 1, limit = 6) => {
  try {
    const { data } = await AuthBackend.get(`campaign/placements/${uniqueId}`, {
      params: {
        sort: 'creative',
        q: search,
        order: 'desc',
        paginated: true,
        limit,
        page,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};


// get All Creatives 
export const getAllCreatives = async (page, search, limit, adType, dimension, widgetId, userId, sortBy, sortOrder) => {

  try {
    const params = {
      page,
      q: search,
      limit,
      paginated: true,
      sortBy,
      sortOrder,
    };

    if (adType) {
      params.adType = adType;
    }
    if (dimension) {
      params.dimension = dimension;
    }
    if (widgetId) {
      params.widgetId = widgetId;
    }
    if (userId) {
      params.userId = userId;
    }

    const {data} = await AuthBackend.get('creative', { params });
    return data;

  } catch (error) {

    throw error;

  }
}


// get All Users 
  export const getCreativeUsers = async (search) => {

    try {
  
      const {data} = await AuthBackend.get(`creative-users?q=${search}`);
      return data;
  
    } catch (error) {
  
      throw error;
  
    }
  }


// get All Creative dimension
export const getCreativeSizes = async (search) => {

  try {

    const {data} = await AuthBackend.get(`creative-dimensions?q=${search}`);
    return data;

  } catch (error) {

    throw error;

  }
}



// get All Creative Types
export const getCreativeTypes = async (search = '') => {

  try {

    const {data} = await AuthBackend.get(`creatives/ad-types?q=${search}`);
    return data;

  } catch (error) {

    throw error;

  }
}


// get All Creative Widgets
export const getCreativeWidgets = async (search) => {

  try {

    const {data} = await AuthBackend.get(`creative-widgets?q=${search}`);
    return data;

  } catch (error) {

    throw error;

  }
}


// get All  Widgets
export const getAllWidgets = async (search = '') => {

  try {

    const {data} = await AuthBackend.get(`creative-widgets?q=${search}`);
    return data;

  } catch (error) {

    throw error;

  }
}


// get Template dimensions/ sizes
export const getTemplateSizes = async () => {

  try {

    const {data} = await AuthBackend.get(`template-dimensions`);
    return data;

  } catch (error) {

    throw error;

  }
}

// get users
export const getUsersList = async (page = 1, search = "", sort, order) => {
  try {
    const { data } = await AuthBackend.get(
      `user?sort=${sort}&order=${order}&page=${page}&q=${search}&limit=20`
    );
    return data;
  }catch(error){
    throw error
  }
}

/**
 * Impersonate a tenant
 * @async
 * @function impersonateTenant
 * @param {number|string} tenantId - The ID of the tenant to impersonate
 * @return {Promise<Response>} The raw response object
 */
export const impersonateTenant = async (tenantId) => {
  try {
    // Use AuthBackend to ensure auth headers and interceptors are applied
    const response = await AuthBackend.post(`switch-tenant/${tenantId}`);
    return response;
  } catch (error) {
    throw handleError(error);
  }
};


// get Template Types list
export const getTemplateTypes = async () => {

  try {

    const {data} = await AuthBackend.get(`template-type-list?withAll=true&withCustom=true&withTemplateCount=true`);
    return data;

  } catch (error) {

    throw error;

  }
}


// get single Template Detail by Id
export const getTemplateById = async (templateID) => {

  try {

    const {data} = await AuthBackend.get(`template/${templateID}`);
    return data;

  } catch (error) {

    throw error;

  }
}


// get More Like templates
export const getLikeMoreTemplates = async (templateID) => {

  try {

    const {data} = await AuthBackend.get(`template/more-like-this/${templateID}`);
    return data;

  } catch (error) {

    throw error;

  }
}


// Convert Creative IN to template
export const moveCreativeIntoTemplate = async (name, creativeId,  category) => {
  try {
    const { data } = await AuthBackend.post(`create-custom-template`, {name, creativeId,  category});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// get Template preview data
export const getTemplatePreviewData = async (templateID) => {

  try {

    const {data} = await AuthBackend.get(`template-preview/${templateID}`);
    return data;

  } catch (error) {

    throw error;

  }
}


// Refresh share id
export const refreshBrandKitShareId = async (assetFolder, type) => {
  try {
    const { data } = await AuthBackend.put(`brandkit/${assetFolder}/refresh-share-id`, { type });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
// fetch widget category 
export const fetchWidgetCategories = async () => {
  try {
    const { data } = await AuthBackend.get(`widget-category`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// Rename logo
export const updateName = async ( id, name, accessId = null, assetFolderId, hexacode, brandKitId) => {
  try {
    const { data } = await AuthBackend.put(`asset/${id}`, { name , accessId, assetFolderId, path:hexacode, brandKitId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Duplicate asset
export const duplicateAssets = async ( assetId, name, assetFolderId, accessId = null, groupId, brandKitId) => {
  try {
    const { data } = await AuthBackend.post(`duplicate-asset/${assetId}`, {name, assetFolderId, accessId, groupId, brandKitId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Role Creation
export const createCustomRole = async (type, role, accessId, brandkitId) => {
  try {
    const { data } = await AuthBackend.put(`/brandkit/${brandkitId}/create-role`, {accessId, type, role});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// get Template preview data
export const getBrandKitDataOnSharePage = async (brandkitId, type,  accessId = null) => {

  try {

    const {data} = await AuthBackend.get(`asset-folder/${brandkitId}?accessId=${accessId}&type=${type}`);
    return data;

  } catch (error) {

    throw error;

  }
}


// SET Logo Role
export const setAssetRole = async (assetId, role, assetFolderId, variant,  accessId, brandKitId ) => {

  try {

    const {data} = await AuthBackend.put(`/set-asset-role/${assetId}?accessId=${accessId}`, {role, assetFolderId, brandKitId, variant});
    return data;

  } catch (error) {

    throw error;

  }
}

// Create custom Role in Brandkit detail page
export const createCustomRoleInDetailPage = async (type, role, brandkitId, accessId, brandKitId) => {
  try {
    const { data } = await AuthBackend.put(`/brandkit/${brandkitId}/create-role`, {type, role, accessId, brandKitId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Delete Brandkit  color
export const deleteBrandkitColor = async ( brandkitId, colorId, accessId = null) => {
  try {
    const { data } = await AuthBackend.put(`/brandkit/${brandkitId}/delete-color`, {colorId, accessId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};




// SET Role on Color
export const setColorRole = async ( brandkitId, colorId, role, accessId = null) => {
  try {
    const { data } = await AuthBackend.put(`/brandkit/${brandkitId}/set-color-role`, {colorId, role, accessId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};




/** 
  
  Create Folder/ Group Inside Brand kit assets

  brandkit/{asset_folder}/create-group

*/ 

export const createAssetBrandkitFolder = async ( name,  type = 'brand_kit_sub_folder', parentId,  assetType, brandKitId, accessId) => {
  try {
    const { data } = await AuthBackend.post(`/asset-folder`, {name,   type,   parentId,  data:{ type:assetType },  brandKitId ,  accessId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**   
 * 
 * Rename Brand kit Asset Group
 * 
 */
export const renameBrandKitGroup = async ( brandkitId, type, currentGropId, group, accessId) => {
  try {
    const { data } = await AuthBackend.put(`/brandkit/${brandkitId}/rename-group`, { type , group, currentGropId, accessId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**
 * DUPLICATE Brand kit Asset Group
 * 
 */
export const duplicateBrandKitGroup = async ( brandkitId, type, group, asset_ids, accessId) => {
  try {
    const { data } = await AuthBackend.put(`/brandkit/${brandkitId}/create-group`, { type , group, asset_ids, accessId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


/**
 * DELETE  Brand kit Asset Group
 * 
 */
export const deleteBrandKitGroup = async ( brandkitId, type, group, asset_ids, accessId = null) => {
  try {
    const { data } = await AuthBackend.put(`/brandkit/${brandkitId}/delete-group`, { type , group, asset_ids, accessId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};




// Move Asset to Group
export const moveAssetToGroup = async ( assetId, folderId, currentFolderId, brandKitId, accessId ) => {
  try {
    const { data } = await AuthBackend.put(`/change-asset-folder/${assetId}`, { folderId, currentFolderId, brandKitId, accessId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Remove Asset From Group
export const removeAssetFromGroup = async ( assetId,groupId, accessId = null, assetFolderId) => {
  try {
    const { data } = await AuthBackend.put(`/remove-asset-group/${assetId}`, {groupId, accessId, assetFolderId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// Move Color to Group
export const moveColorToGroup = async ( assetId,groupId, currentGroupId = null,  accessId = null) => {
  try {
    const { data } = await AuthBackend.put(`/asset-folder/${assetId}`, {groupId, accessId, currentGroupId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Asset Uploader
export const uploadAsset = async ( name, fileType, type, assetFolderId,  accessId = null, fileName, brandKitId) => {
  try {
    const { data } = await AuthBackend.post(`/asset`, { path:name, fileType, type, assetFolderId , name: fileName, accessId, brandKitId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// ATTACH FOLDER
export const attachFolderAsset = async ( id, assetIds, accessId, brandKitId) => {
  try {
    const { data } = await AuthBackend.post(`/attach-asset-to-folder/${id}`, { assetIds, accessId , brandKitId});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// GET GROUPS DATAS
export const getGroupAssets = async ( groupId, type, page, accessId, brandKitId, search = '') => {
  try {
    const { data } = await AuthBackend.get(`asset-folder/${groupId}?type=${type}&page=${page}&accessId=${accessId}&brandKitId=${brandKitId}&q=${search}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Duplicate  asset Folder brandkit
export const duplicateAssetFolder = async ( asset_folder, name, accessId = null, brandKitId) => {
  try {
    const { data } = await AuthBackend.post(`duplicate-asset-folder/${asset_folder}`, { name, accessId, brandKitId });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// Delete bRAND KIT SUB FOLDER
export const deleteSubFolder = async ( id, accessId, brandKitId ) => {
  try {
    const { data } = await AuthBackend.delete(`asset-folder/${id}?accessId=${accessId}&brandKitId=${brandKitId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Get Group inside the Brand kit Asset
export const getSubFoldersList = async ( id , type, accessId ) => {
  try {
    const { data } = await AuthBackend.get(`brandkit-subfolders/${id}?type=${type}&accessId=${accessId}&brandKitId=${id}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Font Url update
export const getFontUploadURL = async ( name, path, type,  fileType, assetFolderId, accessId = null, brandKitId = null ) => {
  try {
    const { data } = await AuthBackend.post(`asset`, {
      name, path, type, fileType, assetFolderId, accessId, brandKitId
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Font Update
export const updateFontPropertie = async ( assetId, fontStyle, fontSize,  fontWeight, variant = 'default', accessId, brandKitId ) => {
  try {
    const { data } = await AuthBackend.put(`/asset/${assetId}`, { fontStyle, fontSize ,  accessId, brandKitId ,  fontWeight, variant});
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// ADD varient
export const addFontVarient = async ( assetId, accessId = null, brandKitId = null ) => {
  try {
    const { data } = await AuthBackend.post(`/add-font-vairant`, {
      assetId, accessId, brandKitId
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};



// Font varient remove
export const removeFontVariant = async ( assetId,  variant,  accessId = null, brandKitId = null ) => {
  try {
    const { data } = await AuthBackend.post(`/remove-font-vairant`, {
      assetId, variant, accessId, brandKitId
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

// layout api
export const getLayouts = async () => {
  try {
    const { data } = await AuthBackend.get(`/layout`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
// Get Brand kit's Creatives
// api/v1/brandkit-by-creative/{creativeUniqueId}

export const getCreativeBrandKit = async ( creativeUniqueId ) => {
  try {
    const { data } = await AuthBackend.get(`/brandkit-by-creative/${creativeUniqueId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getLayoutData = async (layoutId) => {
  try {
    const { data } = await AuthBackend.get(`layout/${layoutId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const deleteLayout = async (layoutId) => {
  try {
    const { data } = await AuthBackend.delete(`layout/${layoutId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// GET Brand Kit Colors
// creative-brandkit-assets/{creativeId}?type=color
export const getBrandKitColors = async ( creativeId ) => {
  try {
    const { data } = await AuthBackend.get(`creative-brandkit-assets/${creativeId}?type=color`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getLayoutByCategory = async (category) => {
  try {
    const { data } = await AuthBackend.get(`layouts-by-category?category=${category}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Get Brand kit fonts
export const getBrandKitFonts = async ( creativeId ) => {
  try {
    const { data } = await AuthBackend.get(`creative-brandkit-assets/${creativeId}?type=font`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// Get CReative version
export const getCreativeVersion = async ( creativeUniqueId ) => {
  try {
    const { data } = await AuthBackend.get(`creative-versions/${creativeUniqueId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


// GET Trash Details
export const getTrashedContent = async (type, search, page=1) => {
  try {
    const {data} = await AuthBackend.get(`/trash?type=${type}&keyword=${search}&page=${page}`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
};

// GET Trash 
export const getTrashedItemCounts = async () => {
  try {
    const {data} = await AuthBackend.get(`/trash-item-counts`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}

// Delete Trash Item
export const deleteTrashItem = async (type, uniqueId) => {
  try {
    const {data} = await AuthBackend.post(`/trash/destroy`, {
      type,
      uniqueId
    });
    return data;
  } catch (error) {
    throw handleError(error);
  }
};



// Restore Trash Item
export const restoreTrashItem = async (type, uniqueId) => {
  try {
    const {data} = await AuthBackend.post(`/trash/restore`, {
      type,
      uniqueId
    });
    return data;
  } catch (error) {
    throw handleError(error);
  }
};



// GET Google fonts
export const getGoogleFonts = async (keyword = '', page = 1) => {
  try {
    const {data} = await CentralBackend.get(`/get-google-fonts?keyword=${keyword}&page=${page}&limit=15`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}


// GET Google Font Variants
export const getGoogleFontVariants = async (family) => {
  try {
    const { data } = await CentralBackend.get(`/get-google-font-variants/${encodeURIComponent(family)}`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}

// GET Custom Font Variants (uploaded / brandkit fonts)
export const getCustomFontVariants = async (family) => {
  try {
    const { data } = await AuthBackend.get(`get-custom-font-variants/${encodeURIComponent(family)}`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}



//GET schedule Report API
export const getScheduleReports = async (search = '', page= 1) => {
  try {
    const {data} = await AuthBackend.get(`/reports/schedule?keyword=${search}&page=${page}`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}

//GET generated Report API
export const getGeneratedReports = async (search = '', page = 1) => {
  try {
    const { data } = await AuthBackend.get(`/reports/generate?keyword=${search}&page=${page}`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}


//POST schedule Report 
export const createScheduleReports = async (data) => {
  try {
    const response = await AuthBackend.post(`/reports/schedule`, {...data});
    return response;
  } catch (error) {
    throw handleError(error);
  }
}

//POST generated Report
export const createGeneratedReports = async (data) => {
  try {
    const response = await AuthBackend.post(`/reports/generate`, {...data});
    return response;
  } catch (error) {
    throw handleError(error);
  }
}


// Delete Schedulr report
export const deleteScheduleReport = async (id) => {
  try {
    const response = await AuthBackend.delete(`reports/schedule/${id}`);
    return response;
  } catch (error) {
    throw handleError(error);
  }
}

export const deleteGeneratedReports = async (ids) => {
  try {
    const { data } = await AuthBackend.post(`/reports/generate/batch-delete`, {generated_report_ids: ids});
    return data;
  } catch (error) {
    throw handleError(error);
  }
}

export const retryGeneratedReport = async (id) => {
  try {
    const { data } = await AuthBackend.post(`/reports/generate/${id}/retry`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}


// Active / De active Schedule Report
export const activeOrDeactiveReport = async (scheduleReportId, is_active) => {
  try {
    const {data} = await AuthBackend.post(`/reports/schedule/activate-or-deactivate`, {
      scheduleReportId,
      is_active
    });
    return data;
  } catch (error) {
    throw handleError(error);
  }
};



// Batch delete Schedule Report
export const batchDeleteScheduleReport = async (scheduleReportIds) => {
  try {
    const response = await AuthBackend.post(`reports/schedule/batch-delete`, { schedule_report_ids: scheduleReportIds});
    return response;
  } catch (error) {
    throw handleError(error);
  }
}

//PUT Edit schedule Report 
export const updateScheduleReports = async (id, data) => {
  try {
    const response = await AuthBackend.put(`reports/schedule/${id}`, {...data});
    return response;
  } catch (error) {
    throw handleError(error);
  }
}


// Search for schedule report
export const searchReportlevel = async (query, page = 1, perPage = 10) => {
  try {
    const { data } = await AuthBackend.get(`universal-search?query=${query}&filter[0]=campaigns&filter[1]=creatives&filter[2]=placements&page=${page}&per_page=${perPage}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
}

// Get custom font api
export const getCustomFonts = async (id, page, search) => {
  try {
    const {data} = await AuthBackend.get(`get-custom-fonts/${id}?page=${page}&keyword=${search}&limit=15`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}

export const deleteCustomFont = async (id, assetId) => {
  try {
    const {data} = await AuthBackend.delete(`delete-custom-font/${id}/${assetId}`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}



// Get custom font api
export const getBrandKitFontList = async (id, page = 1, search = '') => {
  try {
    const {data} = await AuthBackend.get(`get-brandkit-fonts/${id}?page=${page}&keyword=${search}&limit=15`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}

// Get widget default assets
export const getWidgetDefaultAssets = async (tagName) => {
  try {
    const {data} = await AuthBackend.get(`get-widget-default-assets?tagName=${tagName}`);
    return data;
  } catch (error) {
    throw handleError(error);
  }
}

//creative thumbnail generation
export const generateCreativeThumbnail = async (creativeId) => {
  try {
    const { data } = await AuthBackend.get(`creative/${creativeId}/generate-thumbnail`);
    return data;
  } catch (err) {
    throw handleError(err);
  } 
}
// Add: Generate a share token for analytics with selected settings
export const generateAnalyticsShareToken = async (type, id, settings) => {
  try {
    const { data } = await AuthBackend.post(`analytics/generate-share-token`, { type, id, settings });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

// Check video url availability
export const getVideoUrlAvailability = async (creative) => {
  try {
    const { data } = await AuthBackend.get(`non-interactive-video-status/${creative}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

// Export MP4 for creative
export const exportCreativeMp4 = async (creative) => {
  try {
    const { data } = await AuthBackend.post(`creatives/${creative}/export-mp4`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

// switch-tenant (child login)
export const switchTenant = async (tenantId) => {
  try {
    const {data} = await AuthBackend.post(`switch-tenant/${tenantId}`);
    return data;
  } catch (error) {
    throw error;
  }
}

export const exitImpersonation = async () => {
  try {
    const {data} = await AuthBackend.post(`auth/exit-impersonation`);
    return data;
  } catch (error) {
    throw error;
  }
}

export const removeImageBackground = async (assetId) => {
  try {
    const { data } = await AuthBackend.post('/remove-bg', { asset_id: assetId });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getAssetStatus = async (assetId) => {
  try {
    const { data } = await AuthBackend.get(`asset-status/${assetId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

// Bulk Creatives Excel Export and Import APIs

export const exportCampaignCreativesBulk = async (payload, asBlob = true) => {
  try {
    const config = asBlob ? { responseType: 'blob' } : {};
    const response = await AuthBackend.post('creatives/bulk-export', payload, config);
    return response;
  } catch (err) {
    throw handleError(err);
  }
};

export const getBulkCreativeExportStatus = async (token) => {
  try {
    const { data } = await AuthBackend.get(`creatives/bulk-export/status/${token}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const downloadBulkCreativeExport = async (token) => {
  try {
    const response = await AuthBackend.get(`creatives/bulk-export/download/${token}`, {
      responseType: 'blob',
    });
    return response;
  } catch (err) {
    throw handleError(err);
  }
};

export const validateBulkCreativeImport = async (formData) => {
  try {
    const { data } = await AuthBackend.post('creatives/bulk-import/validate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const applyBulkCreativeImport = async (payload) => {
  try {
    const { data } = await AuthBackend.post('creatives/bulk-import/apply', payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const createVastProxyCreative = async (payload) => {
  try {
    const { data } = await AuthBackend.post('creative/vast-proxy', payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getVastProxyCreative = async (creativeId) => {
  try {
    const { data } = await AuthBackend.get(`creative/${creativeId}/vast-proxy`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateVastProxyCreative = async (creativeId, payload) => {
  try {
    const { data } = await AuthBackend.post(`creative/${creativeId}/vast-proxy`, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getBulkCreativeImportStatus = async (token) => {
  try {
    const { data } = await AuthBackend.get(`creatives/bulk-import/status/${token}`); 
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


